import React from 'react';
import { InfoIcon } from 'lucide-react';
import { IndependentTooltip } from 'src/components/Tooltip/IndependentTooltip';

export const MatchedExclusionsTooltip: React.FC = () => (
    <IndependentTooltip
        position='bottom'
        underline={false}
        content={
            <div className='text-left'>
                <p className='mb-1'>Accounts are matched if any of the following conditions are met:</p>
                <ul className='list-disc pl-4 mb-1'>
                    <li>Identical Email</li>
                    <li>Identical Phone Number</li>
                    <li>
                        A full match of all four personal details: First Name, Surname, Date of Birth, and Postcode (4/4
                        required)
                    </li>
                </ul>
                <p className='mt-1 font-semibold'>
                    NOTE: Account unlocking requires all matched accounts to be in Cooling Off or Reactivated status.
                </p>
            </div>
        }
    >
        <InfoIcon
            className='size-4 text-muted-foreground cursor-pointer mt-[2px]'
            data-test='matched-exclusions-info-icon'
        />
    </IndependentTooltip>
);
